import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { createCart } from '../../actions/cartActions';
import { SCAN, STORE_LIST } from '../../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import useAxios
 from '../../axios/useAxios';
import ScanButton from '../../components/button/ScanButton';
import penEdit from '../../styles/img/pen-edit.png';
import { isAllowToChangeStore } from '../../utils/Validator';
import { isAppPWA } from '../../utils/helper-functions';
import { notifyInfo } from '../../utils/Notify';
import { useTheme } from 'styled-components';
import { truncate } from '../../utils/StringUtils';
import PrimaryButton from '../../components/button/PrimaryButton';

const ScanFooter = ({ originPath }) => {
  const theme = useTheme();
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const { cartItems, success, loading } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const isPWA = isAppPWA();

  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (success && !cartItems.isPaid && reset) {
    }
  }, [success]);

  const editSelectedStore = () => {
    const encodedStoreName = encodeURIComponent(
      store?.name?.split(' ')[0].toLowerCase() || '',
    );
    if (encodedStoreName?.length > 0) {
      navigate(`${STORE_LIST}?view=stores&company=${encodedStoreName}`, {
        state: { prevPage: originPath },
      });
    }else{
      navigate(STORE_LIST, {
      state: { prevPage: originPath },
    });
    }

  };

  const deployScan = async () => {
    if (
      cartItems?.isPaid ||
      (!cartItems?._id && store?.id) ||
      (!localStorage.getItem('cartItems') && store?.id)
    ) {
      const orderCreate = {
        storeId: store?.id, clientId: user?._id || '', entryQr: localStorage.getItem('entryQr') || '',
      };
      try {
        dispatch(
          createCart(orderCreate, axiosInstance, () => navigate(SCAN)),
        );
      } catch (e) {
        console.error(e);
      }
    } else if (cartItems?._id && localStorage.getItem('cartItems')) {
      navigate(SCAN);
    } else {
      notifyInfo('Il faut d\'abord choisir un magasin 😉');
      navigate(STORE_LIST);
    }
  };

  return (
    <div className="scan-footer">
      {store && store?.id ? (
        <div className="footer-item">
          <div className="store-info">
            <img src={store.logo} alt="logo" className="store-img" />
            <div className="store-detail">
              <div className="store-name pr-4">{truncate(store?.name, 25)}</div>
              <div className="store-city">{truncate(store?.city, 25)}</div>
            </div>
          </div>
          <div className="edit-img-container" onClick={editSelectedStore}>
            <img src={penEdit} alt="logo" className="edit-img" />
          </div>
          <div className={isPWA ? 'footer-item pwa' : 'footer-item'}>
            {theme?.buttonDecorations?.primaryButtonDecorationAccount && (
              <img
                src={
                  theme.buttonDecorations.primaryButtonDecorationAccount.image
                }
                alt="bat"
                className="bat_hallowen"
              />
            )}
            <ScanButton
              onClick={deployScan}
              label={loading ? 'Chargement...' : 'Scanner'}
              store={store}
              editSelectedStore={editSelectedStore}
              disabled={loading}
            />
          </div>
        </div>
      ) : (
        <div className="footer-item">
          <PrimaryButton
            label="Choisir un magasin"
            onClick={editSelectedStore}
          />
        </div>
      )}
    </div>
  );
};
export default ScanFooter;
